export const FETCH_LOCATIONS = {
  START: 'START_FETCH_LOCATIONS',
  COMPLETE: 'COMPLETE_FETCH_LOCATIONS',
  FAIL: 'FAIL_FETCH_LOCATIONS',
  CLEANUP: 'CLEANUP_FETCH_LOCATIONS',
}

export const UPDATE_LOCATION = {
  START: 'START_UPDATE_LOCATION',
  COMPLETE: 'COMPLETE_UPDATE_LOCATION',
  FAIL: 'FAIL_UPDATE_LOCATION',
}

export const UPDATE_LOCATION_STATUS_FLAG = {
  START: 'START_UPDATE_LOCATION_STATUS_FLAG',
  COMPLETE: 'COMPLETE_UPDATE_LOCATION_STATUS_FLAG',
  FAIL: 'FAIL_UPDATE_LOCATION_STATUS_FLAG',
}

export const BULK_UPDATE_LOCATIONS = {
  START: 'START_BULK_UPDATE_LOCATIONS',
  COMPLETE: 'COMPLETE_BULK_UPDATE_LOCATIONS',
  FAIL: 'FAIL_BULK_UPDATE_LOCATIONS',
}

export const UPDATE_LOCATION_TABLE_HOTKEYS = 'UPDATE_LOCATION_HOTKEYS'
